module.exports = __webpack_public_path__ + "static/media/logo.944c5644.png";